import { defineMessages } from 'react-intl';

export default defineMessages({
    registeredOwnersLabel: {
        id: "ml.quoteandbind.pa.vehicle.Registered Owners",
        defaultMessage: "Registered Owner"
    }
})